export default function selector(state) {
  return state.selector
}



// WEBPACK FOOTER //
// ./src/config-builders/project/reducers/selector.js